import { render, staticRenderFns } from "./AbsenceDeleteButton.vue?vue&type=template&id=a23fc228"
import script from "./AbsenceDeleteButton.vue?vue&type=script&lang=js"
export * from "./AbsenceDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports